<div class="version-available">
  <tdv-icon-svg-update-sync
    class="version-available__icon"
  ></tdv-icon-svg-update-sync>

  <div class="version-available__body">
    <span class="version-available__title">{{
      'Update Available' | transloco
    }}</span>
    <span class="version-available__msg">{{ msg | transloco }}</span>
  </div>

  <div tdv-btn-v2-segment-group class="version-available__segment">
    <button
      tdv-btn-v2
      type="button"
      variant="update"
      shape="segment-start"
      (click)="onReload()"
    >
      {{ 'Update' | transloco }}
    </button>
    <button
      tdv-btn-v2
      type="button"
      variant="update"
      shape="segment-end"
      [matMenuTriggerFor]="updateMenu"
      [attr.aria-label]="'Update options' | transloco"
      [tdvTooltip]="{ placement: 'bottom' }"
      [tdvTooltipText]="'btn.more-options' | transloco"
      [tdvTooltipCanShow]="!updateMenuOpen"
      (menuOpened)="updateMenuOpen = true"
      (menuClosed)="updateMenuOpen = false"
    >
      <tdv-icon-svg-desc-sorting-small></tdv-icon-svg-desc-sorting-small>
    </button>
  </div>
</div>

<mat-menu
  #updateMenu="matMenu"
  xPosition="before"
  class="tdv-mat-menu-panel--dark"
>
  <button mat-menu-item type="button" (click)="onClose()">
    {{ 'Later' | transloco }}
  </button>
</mat-menu>
